import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const editPncInformation = (code, data) => apiActionCreator({
  'endpoint': `/part-number-code/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.EDIT_PNC_REQUEST,
    [
      ActionTypes.EDIT_PNC_SUCCESS,
      MessageActions.addMessageBoxInfo('Codigo de número de parte actualizado satisfactoriamente'),
    ],
    [
      ActionTypes.EDIT_PNC_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});
